import React from 'react'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination } from 'swiper'
import styles from './styles.module.scss'
import { rating, ratingAdaptive } from '../../../../routes/rating'
import parse from "html-react-parser"
import useWindowDimensions from '../../../../hooks/useWindowDimensions'

SwiperCore.use([Pagination]);
const Rating = () => {
	const { height, width } = useWindowDimensions()
	return (
		<div className={styles.wrapper}>
			<div className={styles.left}></div>
			<div className={styles.right}>
				<div className={styles.right_wrapper}>
					<p className={styles.title}>Generium - надежный работодатель</p>

					<Swiper
						className={styles.card_list}
						pagination={true}
						spaceBetween={16}
						slidesPerView={3}
						initialSlide={0}
						loop={true}
						speed={5000}
						breakpoints={{
							1440: {
								slidesPerView: 3
							},
							1365: {
								slidesPerView: 3
							},
							1025: {
								slidesPerView: 2.3,
								spaceBetween: 24
							},
							769: {
								slidesPerView: 2.5,
								spaceBetween: 16
							},
							686: {
								slidesPerView: 3,
								spaceBetween: 16
							},
							480: {
								slidesPerView: 2,
								spaceBetween: 16
							},
							380: {
								slidesPerView: 1.5,
								spaceBetween: 16
							},
							320: {
								slidesPerView: 1.3,
								spaceBetween: 16
							}
						}}
					>
						{(width > 1024 ? rating : ratingAdaptive).map(item => (
							<SwiperSlide key={item.id} className={styles.card_wrapper}>
								<div className={styles.card}>
									<img className={styles.card_img} src={item.img} alt={parse(item.title)} draggable='false' />
									<p className={styles.card_text}>{parse(item.text)}</p>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
			</div>
		</div>
	)
}

export default Rating
